<template>
    <pg-page title="De Huisregels van Private Gym"
             header="De Huisregels"
             subtitle="Een fijne gym, doen we samen"
             id="huisregels"
    >

        <div class="mx-auto mt-4">
            <ol class="list-group list-group-numbered">
                <huisregel>
                    Help je mede-leden als je ziet dat ze hulp nodig hebben
                    <template v-slot:subheading>
                        Maar respecteer ieders "eiland"
                    </template>
                </huisregel>
                <huisregel>
                    Laat je eiland netjes achter
                    <template v-slot:subheading>
                        En als iemand anders hem niet netjes heeft achter gelaten, doe er even melding van via de app
                    </template>
                </huisregel>
                <huisregel>
                    Maak geen foto's of video's van jezelf als er anderen in de gym zijn
                    <template v-slot:subheading>
                        Privacy is een groot goed
                    </template>
                </huisregel>
                <huisregel>
                    Niet staren
                    <template v-slot:subheading>
                        Zorg dat iedereen zich fijn voelt
                    </template>
                </huisregel>
                <huisregel>
                    Niet uitgebreid bellen
                    <template v-slot:subheading>
                        Dit is voor niemand leuk. Als je een belangrijk belletje krijgt, ga dan even in de lounge zitten
                    </template>
                </huisregel>
                <huisregel>
                    Als je iets van een ander eiland pakt (zoals bijv. een 2e kettlebell van X kilo, zet het dan na je training ook terug
                    <template v-slot:subheading>
                        Zo heeft er niemand na jou last van
                    </template>
                </huisregel>
                <huisregel>
                    Zeg ook even hoi tegen de schoonmakers
                    <template v-slot:subheading>
                        Zij zorgen er voor dat jij altijd in een fijne gym sport
                    </template>
                </huisregel>
                <huisregel>
                    Veeg na je training je bankje en andere onderdelen even schoon
                    <template v-slot:subheading>
                        Wel zo fris
                    </template>
                </huisregel>
                <huisregel>
                    Laat het toilet netjes achter, zoals je het thuis ook zou doen
                    <template v-slot:subheading>
                        Tenzij die thuis smerig is, dan graag zoals je het thuis niet doet
                    </template>
                </huisregel>
                <huisregel>
                    Gebruik je gezond verstand
                    <template v-slot:subheading>
                        Een fijne gym, doen we samen
                    </template>
                </huisregel>
            </ol>
        </div>

        <div class="row">
            <div class="col my-5 py-5 text-center">
                <h1 class="mb-5">
                    <strong>
                        Kom even de sfeer proeven! Plan een rondleiding of stel je vraag via Whatsapp!
                    </strong>
                </h1>
                <action-buttons :show-whatsapp="true" :show-inschrijven="true" :colored="true" :icon="true"></action-buttons>
            </div>
        </div>

    </pg-page>
</template>

<script>

import PgPage from "../Components/PgPage";
import ContactModal from "../Components/Contact/ContactModal";
import RondleidingButton from "../Components/Index/RondleidingButton";
import HeaderAndTextBlock from "../Components/Layout/HeaderAndTextBlock";
import ActionButtons from "../Components/Index/ActionButtons";
import Huisregel from "../Components/Huisregels/Huisregel";

export default {
    components: {Huisregel, ActionButtons, HeaderAndTextBlock, RondleidingButton, ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            showFormModal: false,
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
